import './index.scss'
import {isGutenbergEditorVisible} from "../../src/scripts/helpers";

function init(scope = document) {
    const nodeSelectors = {
        container: '[js-image-descriptions="container"]',
        sliderContainer: '[js-image-descriptions="slider-container"]',
        slider: '[js-image-descriptions="slider"]',
        sliderCaptions: '[js-image-descriptions="slider-captions"]',
        sliderImageTrigger: '[js-image-descriptions="slider-image-trigger"]',
    }

    const containers = scope.querySelectorAll(nodeSelectors.container)

    if (!containers.length) return

    containers.forEach((container) => {
        let sliderImageTriggers = container.querySelectorAll(nodeSelectors.sliderImageTrigger)
        const sliderContainer = container.querySelector(nodeSelectors.sliderContainer);
        const sliderEl = sliderContainer.querySelector(nodeSelectors.slider);
        const sliderCaptionsEl = sliderContainer.querySelector(nodeSelectors.sliderCaptions);
        let swiper, swiperThumbs

        // Slider
        if( sliderContainer ) {
            // Destroy existing swiper instance before re-init
            if (sliderEl.swiper) {
                sliderEl.swiper.destroy(true, true);
            }

            if (sliderCaptionsEl.swiper) {
                sliderCaptionsEl.swiper.destroy(true, true);
            }

            const swiperThumbs = new Swiper(sliderCaptionsEl, {
                loop: true,
                spaceBetween: 10,
                allowTouchMove: false,
                slidesPerView: 1,
                freeMode: true,
                watchSlidesProgress: true,
                autoHeight: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
            });

            const settings = {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                speed: 400,
                allowTouchMove: false,
                effect: "creative",
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: ["-20%", 0, -1],
                    },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                thumbs: {
                    swiper: swiperThumbs,
                },
            };

            swiper = new Swiper(sliderEl, settings);

            if( sliderImageTriggers ) {
                sliderImageTriggers.forEach(trigger => {
                    trigger.addEventListener('mouseover', () => {
                        let target = trigger.textContent

                        if( target ) {
                            let sliderSlides = sliderEl.querySelectorAll('.swiper-slide')

                            sliderSlides.forEach((slide, index) => {
                                let currentSlideTriggerText = slide.getAttribute('data-slide-trigger-text')

                                if( currentSlideTriggerText === target ) {
                                    sliderImageTriggers.forEach(trigger => {
                                        trigger.classList.remove('gallery-image-trigger--active')
                                    })

                                    swiper.slideTo(index)
                                    trigger.classList.add('gallery-image-trigger--active')
                                }
                            })
                        }
                    })
                })
            }
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    if ( window.acf ) {
        // Only in block editor preview
        window.acf.addAction('render_block_preview/type=images-description', ($block) => {
            const blockEl = $block[0] || $block;
            init(blockEl);
        });
    } else if( !isGutenbergEditorVisible() ) {
        // Only in frontend
        init()
    }
});